import { render } from "./attendance.vue?vue&type=template&id=ff6bab30&scoped=true"
import script from "./attendance.vue?vue&type=script&lang=js"
export * from "./attendance.vue?vue&type=script&lang=js"

import "./attendance.vue?vue&type=style&index=0&id=ff6bab30&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6bab30"]])

export default __exports__